import { CreateApplicationInfoMark } from "../create-application-info-mark";

export const CreateApplicationDocumentsHelpSection = () => (
  <div className="flex flex-col gap-2">
    <h2 className="text-type-common heading-h4 text-2xl leading-8">Требуемые документы</h2>
    <p className="paragraph-base text-type-minor text-xl leading-8">Прикрепите соответствующий документ в поле</p>
    <p className="paragraph-sm text-type-common">
      <span className="text-system-error-50">*</span> Обязательные для загрузки документы
    </p>
    <div className="flex items-start gap-2">
      <CreateApplicationInfoMark
        description="Наведите на значок рядом с документом, чтобы увидеть дополнительную подсказку."
        ariaLabel="Показать подсказку о документе"
        maxWidth="555px"
      />
      <p className="paragraph-sm text-type-common">Подробнее о документе смотрите в подсказке</p>
    </div>
  </div>
);
